(function($, factory) {
    'use strict';

    /**
     * Is the element inside a modal?
     */
    function isInsideModal(element) {

        return ($(element).closest('.mfp-content')[0] != null);

    }


    /**
     * Is the element a form?
     */
    function isForm(element) {

        return (element.nodeName === 'FORM');

    }


    /**
     * Open remote content inside the modal popup.
     */
    function openAjax(src, settings) {

        var mfp = $.magnificPopup.instance;

        // Let MagnificPopup load the content, if not already open
        if (!mfp || !mfp.isOpen) {

            $.magnificPopup.open({
                type: 'ajax',
                items: {
                    src: src
                },
                ajax: {
                    settings: settings
                }
            });

            return;

        }

        // Otherwise, we handle the content ourselves...


        // Transition-out the current content
        mfp.wrap.stop(true, false)
            .addClass('mfp-ready mfp-removing')
        ;

        // Remote call to get the new content
        $.ajax(src, $.extend({}, settings, {

            success: function(data) {

                // Abort, if the modal has been closed
                if (!mfp.isOpen) {
                    return;
                }

                // Queue functions to transition-in the new content
                mfp.wrap.stop(true, false)
                    .css('display', 'none')
                    .removeClass('mfp-ready mfp-removing')
                    .delay(25)
                    .queue(function(next) {
                        $(this).css('display', '');
                        next();
                    })
                    .delay(25)
                    .queue(function(next) {
                        $(this).addClass('mfp-ready');
                        next();
                    })
                ;

                // Hack MagnificPopup's internal settings with the new content
                mfp.st = $.extend(true, {}, $.magnificPopup.defaults, {
                    type: 'inline',
                    items: {
                        src: data
                    }
                });

                // Re-open the popup
                $.magnificPopup.open(mfp.st);

            }

        }));

    }


    /**
     * Attach a modal handler to the given form element.
     */
    function formHandler(element, options) {

        $(element).on('submit', function(event) {

            var src = element.action;
            if (!src) {
                return;
            }

            openAjax(src, {
                method:    'POST',
                data:      $(this).serialize(),
                dataType:  'html',
                cache:     false
            });

            event.preventDefault();

        });

    }


    /**
     * Attach an AJAX-based modal handler to the given element.
     */
    function ajaxHandler(element, options) {

        $(element).on('click', function(event) {

            var src = $(event.currentTarget).attr('href');
            if (!src) {
                return;
            }

            openAjax(src);

            event.preventDefault();

        });

    }


    /**
     * Make the element open a modal popup when activated.
     */
    function modalOpener(element, options) {

        if (isForm(element)) {
            formHandler(element, options);
        }

        else {
            ajaxHandler(element, options);
        }

    }


    /**
     * Make the element re-use the modal popup when activated.
     */
    function modalReuser(element, options) {

        if (isInsideModal(element)) {
            modalOpener(element, options);
        }

    }


    // Attach factory functions to alloy
    factory.modalOpener = modalOpener;
    factory.modalReuser = modalReuser;

}(jQuery, mtl.alloy.factory));
